<template>
    <div class="team_store">
        <section class="breadcrumb-section pb-0">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link to="/">Home</router-link>
                        </li>
                        <!-- <li class="breadcrumb-item"><a href="#">Cart</a></li> -->
                        <li class="breadcrumb-item active" aria-current="page">
                            Team Store
                        </li>
                    </ol>
                </nav>
            </div>
        </section>
        <section class="store_banner team_store_banner_sec mt_20">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-12 col-lg-6 text-left">
                        <h1 class="banner_heading2 text-white mb_30">
                            Team Store
                        </h1>
                        <a
                            href="#"
                            class="team_store_banner_btn btn bg-transparent btn_outline_white border_secondary_white text_white py_18 px_36"
                            >Shop By State, City or School</a
                        >
                        <a
                            href="/team/create-team-store"
                            class="team_store_banner_btn btn btn_orange bg_primary_orange text_white py_18 px_60 ml_24"
                            >Create TEAM Store</a
                        >
                    </div>
                    <div class="col-md-12 col-lg-6 store_code">
                        <div class="store_code_box">
                            <h1 class="font_size_35 text_white">
                                I have a store code
                            </h1>
                            <div class="input-group mt_10">
                                <input
                                    type="text"
                                    class="form-control bg-transparent text-white mt-auto ihave_input"
                                    placeholder="Enter code"
                                    aria-label="Username"
                                    aria-describedby="basic-addon1"
                                />
                                <div class="input-group-prepend ml-auto">
                                    <a
                                        href="#"
                                        class="btn bg-transparent btn_outline_white border_secondary_white text_white py_12 px_44"
                                        >Submit</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section
            class="search_for_product team_store_searc_product_mainsec py_42"
        >
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div
                            class="heading_with_search d-md-flex align-items-center"
                        >
                            <h1 class="heading1">Search For Product</h1>
                            <div
                                class="serach d-flex ml-auto position-relative"
                            >
                                <label>Search</label>
                                <div class="search_field pl_24">
                                    <input
                                        type="text"
                                        placeholder="e.g. T-Shirt, Cap"
                                        class="form-control team_searc_input"
                                    />
                                    <a href="#" class="search_icon"
                                        ><img
                                            src="/maincss/images/side_bar_serach.svg"
                                            alt=" "
                                    /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt_8">
                    <div class="col-md-4 col-6 col-lg-3 col-xl-2">
                        <div class="product_listing mt_62">
                            <a
                                href="#"
                                class="text_primary d-flex align-items-center"
                                ><img
                                    src="/maincss/images/link_blue_arow.svg"
                                    alt=" "
                                    class="pr_14"
                                />T-Shirts</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3 col-xl-2">
                        <div class="product_listing mt_62">
                            <a
                                href="#"
                                class="text_primary d-flex align-items-center"
                                ><img
                                    src="/maincss/images/link_blue_arow.svg"
                                    alt=" "
                                    class="pr_14"
                                />Polos/Knits</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3 col-xl-2">
                        <div class="product_listing mt_62">
                            <a
                                href="#"
                                class="text_primary d-flex align-items-center"
                                ><img
                                    src="/maincss/images/link_blue_arow.svg"
                                    alt=" "
                                    class="pr_14"
                                />Swatshirts/Fleece</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3 col-xl-2">
                        <div class="product_listing mt_62">
                            <a
                                href="#"
                                class="text_primary d-flex align-items-center"
                                ><img
                                    src="/maincss/images/link_blue_arow.svg"
                                    alt=" "
                                    class="pr_14"
                                />Caps</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3 col-xl-2">
                        <div class="product_listing mt_62">
                            <a
                                href="#"
                                class="text_primary d-flex align-items-center"
                                ><img
                                    src="/maincss/images/link_blue_arow.svg"
                                    alt=" "
                                    class="pr_14"
                                />Activewear</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3 col-xl-2">
                        <div class="product_listing mt_62">
                            <a
                                href="#"
                                class="text_primary d-flex align-items-center"
                                ><img
                                    src="/maincss/images/link_blue_arow.svg"
                                    alt=" "
                                    class="pr_14"
                                />Youth</a
                            >
                        </div>
                    </div>

                    <div class="col-md-4 col-6 col-lg-3 col-xl-2">
                        <div class="product_listing mt_62">
                            <a
                                href="#"
                                class="text_primary d-flex align-items-center"
                                ><img
                                    src="/maincss/images/link_blue_arow.svg"
                                    alt=" "
                                    class="pr_14"
                                />Woven/Dress Shirts</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3 col-xl-2">
                        <div class="product_listing mt_62">
                            <a
                                href="#"
                                class="text_primary d-flex align-items-center"
                                ><img
                                    src="/maincss/images/link_blue_arow.svg"
                                    alt=" "
                                    class="pr_14"
                                />Workwear</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3 col-xl-2">
                        <div class="product_listing mt_62">
                            <a
                                href="#"
                                class="text_primary d-flex align-items-center"
                                ><img
                                    src="/maincss/images/link_blue_arow.svg"
                                    alt=" "
                                    class="pr_14"
                                />Bags</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3 col-xl-2">
                        <div class="product_listing mt_62">
                            <a
                                href="#"
                                class="text_primary d-flex align-items-center"
                                ><img
                                    src="/maincss/images/link_blue_arow.svg"
                                    alt=" "
                                    class="pr_14"
                                />Accessories</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3 col-xl-2">
                        <div class="product_listing mt_62">
                            <a
                                href="#"
                                class="text_primary d-flex align-items-center"
                                ><img
                                    src="/maincss/images/link_blue_arow.svg"
                                    alt=" "
                                    class="pr_14"
                                />Pens</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3 col-xl-2">
                        <div class="product_listing mt_62">
                            <a
                                href="#"
                                class="text_primary d-flex align-items-center"
                                ><img
                                    src="/maincss/images/link_blue_arow.svg"
                                    alt=" "
                                    class="pr_14"
                                />Journals</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3 col-xl-2">
                        <div class="product_listing mt_62">
                            <a
                                href="#"
                                class="text_primary d-flex align-items-center"
                                ><img
                                    src="/maincss/images/link_blue_arow.svg"
                                    alt=" "
                                    class="pr_14"
                                />Drinkware</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3 col-xl-2">
                        <div class="product_listing mt_62">
                            <a
                                href="#"
                                class="text_primary d-flex align-items-center"
                                ><img
                                    src="/maincss/images/link_blue_arow.svg"
                                    alt=" "
                                    class="pr_14"
                                />Mugs</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3 col-xl-2">
                        <div class="product_listing mt_62">
                            <a
                                href="#"
                                class="text_primary d-flex align-items-center"
                                ><img
                                    src="/maincss/images/link_blue_arow.svg"
                                    alt=" "
                                    class="pr_14"
                                />Jackets</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3 col-xl-2">
                        <div class="product_listing mt_62">
                            <a
                                href="#"
                                class="text_primary d-flex align-items-center"
                                ><img
                                    src="/maincss/images/link_blue_arow.svg"
                                    alt=" "
                                    class="pr_14"
                                />Pents</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3 col-xl-2">
                        <div class="product_listing mt_62">
                            <a
                                href="#"
                                class="text_primary d-flex align-items-center"
                                ><img
                                    src="/maincss/images/link_blue_arow.svg"
                                    alt=" "
                                    class="pr_14"
                                />Cinch Packs</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3 col-xl-2">
                        <div class="product_listing mt_62">
                            <a
                                href="#"
                                class="text_primary d-flex align-items-center"
                                ><img
                                    src="/maincss/images/link_blue_arow.svg"
                                    alt=" "
                                    class="pr_14"
                                />Duffels</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section
            class="smilar_product team_store_similar_product_sec bg_primary_light_white pt_64 mb_50 mt_56"
        >
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h2 class="heading2">Recommended Products</h2>
                    </div>
                </div>
                <div class="row mt_52">
                    <div class="col-md-4 col-lg-3 col-xl-2">
                        <div class="product bg-transparent">
                            <div
                                class="product_image position-relative d-flex justify-content-center align-items-center bg-white"
                            >
                                <img
                                    src="/maincss/images/similar_product_1.png"
                                    alt=" "
                                    class="w-auto"
                                />
                            </div>
                            <div class="product_content">
                                <h5 class="font_size_18">PC55Y</h5>
                                <p>Port &amp; Company® Youth</p>
                                <p>Core Blend Tee</p>

                                <p>Price: $6.00</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-3 col-xl-2">
                        <div class="product bg-transparent">
                            <div
                                class="product_image position-relative d-flex justify-content-center align-items-center bg-white"
                            >
                                <img
                                    src="/maincss/images/similar_product_1.png"
                                    alt=" "
                                    class="w-auto"
                                />
                            </div>
                            <div class="product_content">
                                <h5 class="font_size_18">PC55Y</h5>
                                <p>Port &amp; Company® Youth</p>
                                <p>Core Blend Tee</p>

                                <p>Price: $6.00</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-3 col-xl-2">
                        <div class="product bg-transparent">
                            <div
                                class="product_image position-relative d-flex justify-content-center align-items-center bg-white"
                            >
                                <img
                                    src="/maincss/images/similar_product_1.png"
                                    alt=" "
                                    class="w-auto"
                                />
                            </div>
                            <div class="product_content">
                                <h5 class="font_size_18">PC55Y</h5>
                                <p>Port &amp; Company® Youth</p>
                                <p>Core Blend Tee</p>

                                <p>Price: $6.00</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-3 col-xl-2">
                        <div class="product bg-transparent">
                            <div
                                class="product_image position-relative d-flex justify-content-center align-items-center bg-white"
                            >
                                <img
                                    src="/maincss/images/similar_product_1.png"
                                    alt=" "
                                    class="w-auto"
                                />
                            </div>
                            <div class="product_content">
                                <h5 class="font_size_18">PC55Y</h5>
                                <p>Port &amp; Company® Youth</p>
                                <p>Core Blend Tee</p>

                                <p>Price: $6.00</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-3 col-xl-2">
                        <div class="product bg-transparent">
                            <div
                                class="product_image position-relative d-flex justify-content-center align-items-center bg-white"
                            >
                                <img
                                    src="/maincss/images/similar_product_1.png"
                                    alt=" "
                                    class="w-auto"
                                />
                            </div>
                            <div class="product_content">
                                <h5 class="font_size_18">PC55Y</h5>
                                <p>Port &amp; Company® Youth</p>
                                <p>Core Blend Tee</p>

                                <p>Price: $6.00</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-3 col-xl-2">
                        <div class="product bg-transparent">
                            <div
                                class="product_image position-relative d-flex justify-content-center align-items-center bg-white"
                            >
                                <img
                                    src="/maincss/images/similar_product_1.png"
                                    alt=" "
                                    class="w-auto"
                                />
                            </div>
                            <div class="product_content">
                                <h5 class="font_size_18">PC55Y</h5>
                                <p>Port &amp; Company® Youth</p>
                                <p>Core Blend Tee</p>

                                <p>Price: $6.00</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: "TeamStore",
    components: {},
    mounted() {
        document.body.classList.remove("bg_primary_light_white");
        document.body.classList.add("footer_spacing_mange");
    },
    computed: {
        // ...mapGetters(["isAuthenticated", "tags"]),
        // tag() {
        //   return this.$route.params.tag;
        // }
    }
};
</script>
